/*
 *
 * Achievements constants
 *
 */

export const SLICE_NAME = 'achievements';
